import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { Users, Target, Heart } from 'lucide-react';

const NSS = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Navigation />
      
      <div className="container mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="mb-8">
            <h1 className="text-4xl font-bold text-[#000066] mb-4 flex items-center gap-3">
              <Users className="w-10 h-10" />
              National Service Scheme (NSS)
            </h1>
            <div className="h-1 w-32 bg-[#FF4500]"></div>
          </div>

          <div className="prose max-w-none">
            <div className="mb-8">
              <h2 className="text-2xl font-bold text-[#000066] mb-4 flex items-center gap-2">
                <Target className="w-6 h-6 text-[#FF4500]" />
                About NSS
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                The National Service Scheme (NSS) is a Central Sector Scheme of Government of India, 
                Ministry of Youth Affairs & Sports. It provides opportunity to the student youth of 
                11th & 12th Class of schools at +2 Board level and student youth of Technical Institution, 
                Graduate & Post Graduate at colleges and University level of India to take part in various 
                government led community service activities & programmes.
              </p>
              <p className="text-gray-700 leading-relaxed">
                The sole aim of the NSS is to provide hands on experience to young students in delivering 
                community service. Since inception of the NSS in the year 1969, the number of students 
                strength increased from 40,000 to over 3.8 million up to the end of March 2018 students 
                in various universities, colleges and Institutions of higher learning have volunteered to 
                take part in various community service programmes.
              </p>
            </div>

            <div className="mb-8">
              <h2 className="text-2xl font-bold text-[#000066] mb-4 flex items-center gap-2">
                <Heart className="w-6 h-6 text-[#FF4500]" />
                NSS Motto
              </h2>
              <div className="bg-gradient-to-r from-[#000066] to-[#000099] text-white p-6 rounded-lg">
                <p className="text-2xl font-bold text-center mb-2">"NOT ME, BUT YOU"</p>
                <p className="text-center">This reflects the essence of democratic living and upholds the need for selfless service.</p>
              </div>
            </div>

            <div className="mb-8">
              <h2 className="text-2xl font-bold text-[#000066] mb-4">NSS Symbol</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                The NSS symbol is based on the 'Rath' wheel of the Konark Sun Temple situated in Orissa. 
                These giant wheels of the Sun Temple portray the cycle of creation, preservation and release, 
                and signify the movement in life across time and space. The design of the symbol, a simplified 
                form of the Sun-Chariot wheel primarily depicts movement. The wheel signifies the progressive 
                cycle of life. It stands for continuity as well as change and implies the continuous striving 
                of NSS for social transformation and upliftment.
              </p>
            </div>

            <div className="mb-8">
              <h2 className="text-2xl font-bold text-[#000066] mb-4">NSS Activities at DAV</h2>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#FF4500]">
                  <h3 className="font-bold text-lg mb-2">Regular Activities</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>Blood Donation Camps</li>
                    <li>Cleanliness Drives</li>
                    <li>Tree Plantation</li>
                    <li>Health Awareness Programs</li>
                    <li>Literacy Programs</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#FF4500]">
                  <h3 className="font-bold text-lg mb-2">Special Camps</h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-700">
                    <li>Annual NSS Camp (7 days)</li>
                    <li>Village Adoption Programs</li>
                    <li>Disaster Management Training</li>
                    <li>Social Awareness Campaigns</li>
                    <li>Community Development Projects</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default NSS;